import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Button, Modal } from 'react-bootstrap'
import Configs from './components/configs';
import Data from './components/data';
import ChangePassword from './components/changePassword';
import { NotifyModal } from '../../components/NotifyModal/NotifyModal'
import Grafico from './components/grafico';
import Detalhes from './components/detalhes';
import Reload from '../../components/reload/reload';
import { useParams, useNavigate } from 'react-router-dom';

function ConfigOn(props) {
    const {
        socket,
        type,
        modalShow,
        setModalShow,
        loading,
        setLoading,
        pageConfigs,
        formData,
        medidas,
        details,
        user
    } = props;

    const serial = useParams().id;

    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const [showRebootModal, setShowRebootModal] = useState(false);

    const handlePage = async (number) => {
        setPage(number);
    };

    const reloadEmpresas = async () => {
        const units = JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || [];
        return [...units];
    };

    const verifyEquipment = async (serial) => {
        try {
            const empresasAtualizadas = await reloadEmpresas();
            const empresaEncontrada = empresasAtualizadas.find(empresa =>
                empresa?.equipments?.includes(serial)
            );

            if (!empresaEncontrada) {
                console.warn(`Equipamento com serial ${serial} não encontrado.`);
                handleExit();
            }
        } catch (error) {
            console.error("Erro ao verificar equipamento:", error);
            handleExit();
        }
    };

    useEffect(() => {
        if (serial) {
            verifyEquipment(serial);
        }
    }, [serial]);

    const handleExit = async () => {
        localStorage.removeItem("access_key");
        localStorage.removeItem("page_configs");
        localStorage.removeItem("access_isValid");
        navigate(`/home`);
    };

    const confirmReboot = () => {
        setShowRebootModal(false);
        setLoading(true);

        if (!socket) {
            console.error("Socket is not connected");
            return;
        }
        if (!serial) {
            console.error("Serial number is not available");
            return;
        }
        if (!user) {
            console.error("User is not available");
            return;
        }
        if (!user.email) {
            console.error("User email is not available");
            return;
        }
        if (!user.email.includes("@")) {
            console.error("User email is not valid");
            return;
        }

        socket.send(
            JSON.stringify({
                type: 'message',
                room: serial,
                email: user?.email || "SGU",
                content: {
                    command: 'process',
                    parameters: {
                        command: "reboot",
                    }
                }
            })
        );

        setTimeout(() => {
            setLoading(false);
        }, 60000);
    }

    const handleReboot = () => {
        setShowRebootModal(true);
    }

    return (
        <Container fluid>
            <NotifyModal
                type={type}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            {loading && <Reload />}
            <Row>

                <Col
                    xs={4} sm={5} md={4} lg={3} xl={2}
                    style={{
                        background: "#0C392E",
                        position: "fixed", // Torna a coluna fixa
                        height: "100vh", // Garante que ocupe toda a altura da tela
                        left: 0, // Fixa no lado esquerdo
                        top: 0, // Fixa no topo da tela
                        zIndex: 10 // Garante que fique acima de outros elementos, se necessário
                    }}
                    className='p-0'
                >
                    <Card className='menu-lateral' style={{ background: "#0C392E", height: "100vh" }}>
                        <Button
                            style={{ margin: "1rem 1rem 0px" }}
                            variant={page === 0 ? "success" : "outline-success"}
                            onClick={() => { handlePage(0) }}>Configurações</Button>

                        <Button
                            style={{ margin: "10px 1rem 0px" }}
                            variant={page === 1 ? "success" : "outline-success"}
                            onClick={() => { handlePage(1) }}>Exemplos de Dados</Button>

                        <Button
                            style={{ margin: "10px 1rem 0px" }}
                            variant={page === 2 ? "success" : "outline-success"}
                            onClick={() => { handlePage(2) }}>Gráfico</Button>

                        <Button
                            style={{ margin: "10px 1rem 0px" }}
                            variant={page === 6 ? "success" : "outline-success"}
                            onClick={() => { handlePage(6) }}>Detalhes</Button>

                        <Button
                            style={{ margin: "10px 1rem 0px" }}
                            variant="outline-warning"
                            onClick={() => { handleReboot() }}>Reiniciar Equipamento</Button>

                        <hr style={{ color: "#f4f4f4", marginBottom: 10, marginTop: 10 }} />

                        <Button
                            style={{ marginTop: "auto", marginLeft: "1rem", marginRight: "1rem", marginBottom: "1rem" }}
                            variant="outline-warning"
                            onClick={() => { handleExit() }}>Sair</Button>
                    </Card>
                </Col>

                <Col
                    xs={8} sm={7} md={8} lg={9} xl={10}
                    className='p-3'
                    style={{
                        background: "silver",
                        marginLeft: "auto", // Move o conteúdo para o lado do menu lateral
                        paddingLeft: "calc(16.66667% + 1rem)", // Ajusta o espaço baseado na largura do menu lateral
                        overflowY: "scroll", // Adiciona scroll vertical
                        height: "100vh" // Garante que a altura seja consistente
                    }}
                >
                    {page === 0 && serial && socket ? (
                        <Configs
                            socket={socket}
                            serial={serial}
                            setLoading={setLoading}
                            pageConfigs={pageConfigs}
                            user={user}
                        />
                    ) : page === 1 ? (
                        <Data
                            socket={socket}
                            serial={serial}
                            setLoading={setLoading}
                            formData={formData}
                        />
                    ) : page === 2 ? (
                        <Grafico
                            socket={socket}
                            serial={serial}
                            setLoading={setLoading}
                            medidas={medidas}
                        />
                    ) : page === 3 ? (
                        <ChangePassword
                            socket={socket}
                            serial={serial}
                            setLoading={setLoading}
                        />
                    ) : page === 6 ? (
                        <Detalhes
                            socket={socket}
                            serial={serial}
                            setLoading={setLoading}
                            details={details}
                        />
                    ) : null
                    }
                </Col>
            </Row>
            <Modal show={showRebootModal} onHide={() => setShowRebootModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Reinicialização</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Tem certeza que deseja reiniciar o equipamento?</p>
                    <p style={{ color: '#dc3545' }}>
                        <strong>Atenção:</strong> O equipamento poderá ficar offline por até 2 minutos durante o processo de reinicialização.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRebootModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={confirmReboot}>
                        Reiniciar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default ConfigOn;
